export const FieldInsuredOptional = [
    ['grade', 'grade'],
    ['feedbackComment', 'feedback_comment']
].map(([key, value]) => ({
    label: value,
    type: 'string',
    properties: [key]
}));
